import { BASE_URL, REACT_APP_OLE_API_KEY } from 'config';

export interface DisplayConfigButton {
  code: string;
  button_color: string;
  button_text: string;
  primary_color: string;
  enable: boolean;
  hidden: boolean;
  action: string;
}

export interface DisplayConfig {
  code: string;
  logo: string;
  title: { en: string; es: string; pt: string };
  buttons: DisplayConfigButton[];
}

export const getDisplayConfig = async (code: string): Promise<DisplayConfig | null> => {
  try {
    const response = await fetch(`${BASE_URL}/api-payments/v1/display-configs/${code}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': REACT_APP_OLE_API_KEY,
        'X-User': 'ole-web-application',
      },
    });

    if (!response.ok) return null;

    return await response.json() as DisplayConfig;
  } catch {
    return null;
  }
};
